import * as t from 'ts-schema';
export function createCollectionItemsSchema(itemSchema) {
  return t.object({
    total: t.number,
    items: t.array(itemSchema)
  });
}